import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const EarlyMorning = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 20" {...rest}>
      <path
        d="M7.083 9.583a2.917 2.917 0 0 1 5.834 0M15.833 9.167H17.5M2.5 9.167h1.667M10 3.333V1.667M14.125 5.042L15.3 3.867M4.7 3.867l1.175 1.175M2.5 12.5h8.333M14.167 12.5H17.5M16.667 15h-7.5M3.333 15h2.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

EarlyMorning.propTypes = {
  color: PropTypes.string
};

EarlyMorning.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default EarlyMorning;
